import { render, staticRenderFns } from "./CesionComponent.vue?vue&type=template&id=b8a0de4e&"
import script from "./CesionComponent.vue?vue&type=script&lang=js&"
export * from "./CesionComponent.vue?vue&type=script&lang=js&"
import style0 from "./CesionComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports